import {
  BasicProjectCandidate,
  CoderbyteAssessmentStageActionCandidateStatus,
  CognitiveKind,
  CognitiveTestAssessmentStageActionCandidateStatus,
  DeiStageActionCandidateFragment,
  EnglishProficiencyAssessmentStageActionCandidateStatus,
  FormCandidateModelFragment,
  PersonalityTestAssessmentStageActionCandidateStatus,
  RssAssessmentCandidateFragment,
  ScoreModel,
  StageCandidateStatus,
  User,
} from 'generated/graphql';

export interface IScores {
  id: number;
  score: ScoreModel;
}

export interface IStageValues {
  stageId: number;
  company: number;
}

export interface IStageReset {
  userInfo: User | undefined;
  stageId: number;
  projectId: number;
  companyName: string;
  stageStatus?: StageCandidateStatus;
  stageCandidateId: number;
  companyId: number;
}

export interface IStageResult {
  companyName?: string;
  companyId?: number;
  projectId?: number;
  projectName?: string;
  projectSubId?: string;
  stageId: number;
  stageName: string;
  lastDateOfCandidateAction?: number | null;
  scores?: IScores[];
  totalScore?: IScores;
  stageStatus?: StageCandidateStatus;
  stageCandidateId: number;
  stageCandidateSubId: string;
  projectCandidate?: Pick<
    BasicProjectCandidate,
    'subId' | 'isExpired' | 'expiresAt'
  >;
  candidateName: string;
  candidateId?: number;
  userSubId?: string;
}

export interface IActionsResultTable {
  stageId: number;
  userInfo: User | undefined;
  stageStatus?: StageCandidateStatus;
  projectName?: string;
  filteredTestActionCandidates: IFilteredTestActionCandidate[];
  rssAssessmentCandidates: RssAssessmentCandidateFragment[];
  rsForm?: FormCandidateModelFragment;
  stageCandidateId: number;
  projectCandidate?: Pick<
    BasicProjectCandidate,
    'subId' | 'isExpired' | 'expiresAt'
  >;
  deiForm?: DeiStageActionCandidateFragment | null;
}
export interface IUserReset {
  userInfo: User | undefined;
  stageId: number;
  stageName: string;
  projectId: number;
  lastDateOfCandidateAction?: number | null;
  scores?: IScores[];
  totalScore?: IScores;
  stageStatus?: StageCandidateStatus;
  stageCandidateId: number;
  stageCandidateSubId: string;
  doneFor: number;
  doneBy: number;
  rssAssessmentCandidates: RssAssessmentCandidateFragment[];
  formCandidates?: FormCandidateModelFragment[];
  deiForm?: DeiStageActionCandidateFragment | null;
  filteredTestActionCandidates: IFilteredTestActionCandidate[];
  projectCandidate?: Pick<
    BasicProjectCandidate,
    'subId' | 'isExpired' | 'expiresAt'
  >;
  isCardOpen: boolean;
  setIsCardOpen: () => void;
}

export enum TestActionType {
  COGNITIVE = 'COGNITIVE',
  PERSONALITY = 'PERSONALITY',
  CODERBYTE = 'CODERBYTE',
  ENGLISH_PROFICIENCY = 'ENGLISH_PROFICIENCY',
}

export interface IFilteredTestActionCandidate {
  id: string;
  type: TestActionType;
  assessmentId?: string | null;
  status:
    | CognitiveTestAssessmentStageActionCandidateStatus
    | PersonalityTestAssessmentStageActionCandidateStatus
    | CoderbyteAssessmentStageActionCandidateStatus
    | EnglishProficiencyAssessmentStageActionCandidateStatus;
  // Set for cognitive test action candidates only.
  cognitiveKind?: CognitiveKind | null;
  // Extra-time accommodation (cognitive and Coderbyte only).
  timeModifierPercentage?: number | null;
  // Coderbyte only: the assessment's name and time limit (null when unknown).
  coderbyteAssessmentName?: string | null;
  timeLimitInMinutes?: number | null;
}
